/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-17 18:16:39
 * @LastEditors: susj
 * @LastEditTime: 2020-11-16 20:43:56
 */
/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-17 18:16:39
 * @LastEditors: susj
 * @LastEditTime: 2020-10-20 15:14:54
 */
/* eslint-disable */
import Vue from 'vue';
import { curry } from 'lodash';

import insertObj from '@/utils/insertData';
const DESIGN_DRAFT_WIDTH = 320;
const styleKey = 'commonStyle';

export function getComponentsForPropsEditor(elementName) {
  const Ctor = Vue.component(elementName);
  // TODO 为何直接 return new Ctor() 并将其赋值给 vuex 的 state 会报错：Cannot convert a Symbol value to a string
  return new Ctor().$options.componentsForPropsEditor;
}

export function getVM(pluginName) {
  const Ctor = Vue.component(pluginName);
  return new Ctor();
}
export function swapArray(arr, index1, index2) {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0];
  return arr;
}

export function swapZindex(x, y) {
  const tmp = y[styleKey].zindex;
  y[styleKey].zindex = x[styleKey].zindex;
  x[styleKey].zindex = tmp;
}
/**
 * !#zh 将 px 转换为 rem
 * @param {Number} px
 */
function px2Rem(px) {
  const number = Math.pow(10, 6);
  const val = (px / (DESIGN_DRAFT_WIDTH / 10)) * number;
  const rem = `${Math.round(val) / number}rem`;
  return rem;
}

/**
 *
 * @param {Number} px 元素的某个属性的像素值，比如 height
 * @param {Boolean} isToRem 是否将 px 转换为 rem
 */
export function parsePx(px, isRem = false) {
  if (isRem) return px2Rem(px);
  return `${px}px`;
}

export const genUUID = () =>
  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

export const eleRelativeBox = (box, ele) => {
  const newEle = {};
  if (ele.width / ele.height >= box.width / box.height) {
    if (ele.width > box.width) {
      newEle.width = box.width;
      newEle.height = (ele.height * box.width) / ele.width;
      newEle.left = 0;
      newEle.top = (box.height - newEle.height) / 2;
    } else {
      newEle.width = ele.width;
      newEle.height = ele.height;
      newEle.left = (box.width - newEle.width) / 2;
      newEle.top = (box.height - newEle.height) / 2;
    }
  } else if (ele.height > box.height) {
    newEle.height = box.height;
    newEle.width = (ele.width * box.height) / ele.height;
    newEle.left = (box.width - newEle.width) / 2;
    newEle.top = 0;
  } else {
    newEle.width = ele.width;
    newEle.height = ele.height;
    newEle.left = (box.width - newEle.width) / 2;
    newEle.top = (box.height - newEle.height) / 2;
  }
  return newEle;
}
export function rgb2hex(str) {
  str = str.replace(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/g, function (rgb) {
    const [r, g, b] = rgb.match(/\d+/g);
    return '#' + (r << 16 | g << 8 | b).toString(16);
  });
  return str;

}

export const findObjItem = (obj, ObjKey, findStr) => {
  return obj.find(item => item[ObjKey] == findStr);
}

export const abbr2sty = (str)=> {
 return str.replace(/f-w/g, 'font-weight').replace(/f-st/g, 'font-style').replace(/f-si/g, 'font-size').replace(/t-d/g, 'text-decoration').replace(/t-a/g, 'text-align');
}
export const sty2abbr = (str)=> {
  return str.replace(/font-weight/g, 'f-w').replace(/font-style/g, 'f-st').replace(/font-size/g, 'f-si').replace(/text-decoration/g, 't-d').replace(/text-align/g, 't-a');
}

export const areaFilterName = (areaType,contentType)=> {
  insertObj.insertDataItem[type].filter(item=>{
    return item.val===contentType
  })
 }

 export const sortRoomTypeSentence = (res,category)=> {
  const list = [];
  category.forEach((cate) => {
    let sentence = res.filter(item=>item.categoryName===cate.categoryName)
    let sentenceData = cate; 
    if(sentence.length>0) {
      sentenceData = sentence[0];
    } else {
      sentenceData ={
        ...sentenceData,
        categoryId:sentenceData.id,
        id:null,
        content: ''
      }
    }
    list.push(sentenceData)
  });
  return list;
 }